import { z } from 'zod'
import type { NewsERPSettings } from '../../models/NewsERPSettings'

export const NewsERPSettingsDTO = z.object({
  is_enabled: z.boolean()
})

export type NewsERPSettingsDTO = z.infer<typeof NewsERPSettingsDTO>

export function mapNewsERPSettingsToDTO (model: NewsERPSettings): NewsERPSettingsDTO {
  return {
    is_enabled: model.isEnabled
  }
}

export function mapDTOToNewsERPSettings (dto: NewsERPSettingsDTO): NewsERPSettings {
  return {
    isEnabled: dto.is_enabled
  }
}
